import React, { ReactNode, useContext } from "react";
import className from "classnames";
import { ToggleGroupProps } from "./ToggleGroup.props";
import globalFormStyles from "../global.formElements.module.scss";
import FieldMessage from "../FieldMessage";
import Label from "../Label";
import styles from "../Toggle/Toggle.module.scss";

import { FormContext } from "../../Form";

const ToggleGroup: React.FC<ToggleGroupProps> = (props: ToggleGroupProps) => {
  const { children, id, label, helperText, readOnly } = props;
  const toggleContainerClass = className(globalFormStyles["form-field-container"]);
  const displayLabel = label && <Label id={`label-${id}`} label={label} />;

  const { readOnly: readOnlyForm } = useContext(FormContext);

  const component = (
    <>
      {!readOnly && !readOnlyForm ? displayLabel : null}
      <div className={className(styles["toggles-area"])}>
        {React.Children.map(children, (child: ReactNode) => {
          return React.isValidElement(child) ? React.cloneElement(child) : null;
        })}
        <FieldMessage id={id} helperText={helperText} name="" />
      </div>
    </>
  );

  return <div className={toggleContainerClass}>{component}</div>;
};

export default ToggleGroup;
